<template>
  <div class='footer-container'>
    <div class='footer-main' :style='`display: ${$route.meta.hideFooterLink ? "none" : "block"}`'>
      <div class='list-conent'>
        <div class='product'>
          <div class='title'>产品与服务</div>
          <ul>
            <li @click='redirect("/product/ssyy")'>实时语音</li>
            <li @click='redirect("/product/sssp")'>实时视频</li>
            <li @click='redirect("/product/hdbb")'>互动白板</li>
            <li @click='redirect("/product/hdzb")'>互动直播</li>
            <li @click='redirect("/product/ydlz")'>云端录制</li>
            <li @click='redirect("/product/jstx")'>即时通讯</li>
          </ul>
        </div>
        <div class='resolution'>
          <div class='title'>解决方案</div>
          <ul>
            <li @click='redirect("/resolution/onlineEducation")'>在线教育解决方案</li>
            <li @click='redirect("/resolution/telemedicine")'>远程医疗解决方案</li>
            <li @click='redirect("/resolution/socialEntertainment")'>娱乐社交解决方案</li>
            <li @click='redirect("/resolution/medicalTreatment")'>医学会议解决方案</li>
            <li @click='redirect("/resolution/powerIndustry")'>电力行业解决方案</li>
            <li @click='redirect("/resolution/publicSecurityOrgans")'>公检法解决方案</li>
          </ul>
        </div>
        <div class='service'>
          <div class='title'>开发者资源</div>
          <ul>
            <li @click='redirect("/development")'>新用户指南</li>
            <li @click='redirect("/development")'>文档中心</li>
            <li @click='redirect("/development")'>SDK下载</li>
            <li @click='downLoadApp'>云会议下载</li>
            <!-- <li>问答社区</li> -->
          </ul>
        </div>
        <div class='advice'>
          <div class='title'>关于马兰头</div>
          <ul>
            <li @click='redirect("/about")'>关于我们</li>
            <li @click='redirect("/contact")'>联系我们</li>
            <li @click='redirect("/news")'>新闻动态</li>
            <!-- <li>公司博客</li> -->
          </ul>
        </div>
        <div class='link-us'>
          <div class='title'>关注我们</div>
          <div class='contact-wrapper'>
            <img src="../assets/qrcode.jpg" width="100" height="100"/>
            <div>咨询热线：400-646-1860</div>
            <div>邮箱：developer@mlt-med.com</div>
          </div>
        </div>
      </div>
    </div>
    <copyright></copyright>
  </div>
</template>

<script>
import {  MEETING_DOWNLOAD_URL } from '../utils/constants';
import copyright from './copyright.vue';
export default {
  name: 'Footer',
  components: {
    copyright,
  },
  methods: {
    downLoadApp() {
      window.open(MEETING_DOWNLOAD_URL);
    },
  }
}
</script>

<style lang="less">
.footer-container {
  background: #374367;
  color: #fff;
  position: relative;
  .footer-main {
    display: none;
    width: 80%;
    min-width: 650px;
    max-width: 1200px;
    margin: 0 auto;
    padding-top: 50px;
    .list-conent {
      display: flex;
      justify-content: space-between;
      padding: 0 47px 47px;
      >div {
        margin-right: 20px;
        .title {
          font-size: 18px;
          line-height: 25px;
          margin-bottom: 40px;
        }
        &.product, &.service, &.advice, &.resolution {
          ul li{
            line-height: 18px;
            font-size: 13px;
            cursor: pointer;
            &:hover {
              color: #8DA8FF;
            }
            &:not(:last-child) {
              margin-bottom: 15px;
            }
          }
        }
        &.link-us .contact-wrapper{
          font-size: 13px;
          >div {
            line-height: 18px;
            margin-top: 15px;
          }
          img {
            margin-bottom: 8px;
          }
        }
      }
    }
  }
}
</style>
